import { inject, Injectable } from '@angular/core';

import { EnvironmentService } from '../../../core/environment.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    private environmentService = inject(EnvironmentService);

    navigateToDashboard(route: string) {
        const token = this.environmentService.systemUser?.token;
        const form = document.createElement('form');
        form.method = 'POST';
        //
        form.action = this.environmentService.ctxrootDashboard + '/api/auth/handoff';
        // Direkteinstieg, ohne Auth-Prüfung
        // form.action = this.environmentService.ctxrootDashboard + '/app/#einkaufsauswertung';
        // form.action = 'https://01.dashboards.mws-dev-01.d.orgacard.de/app/#einkaufswert';
        form.target = '_blank';
        //
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'token';
        input.value = token;
        form.appendChild(input);
        //
        const inputRedirectTo = document.createElement('input');
        inputRedirectTo.type = 'hidden';
        inputRedirectTo.name = 'redirect_to';
        inputRedirectTo.value = '/' + route;
        form.appendChild(inputRedirectTo);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
}
